import React from "react";
import { connect } from "react-redux";
import { EMPTY_STRING } from "../../../constants";

const MainContentWrapper = (props) => {
  const { isAuthenticated, className=EMPTY_STRING } = props;
  return (
    <div
      className={`main-content-wrapper ${
        !isAuthenticated ? "hide-scroll" : EMPTY_STRING
      } ${className}`}
    >
      {props.children}
    </div>
  );
};

const mapStateToProps = (state) => ({
  isAuthenticated: state.authReducer.isAuthenticated,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(MainContentWrapper);
